import React, { Suspense, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { getRoutesByUserType, USER_TYPES } from './routeConfig';
import ProtectedRoute from './ProtectedRoute';
import RouteFallback from './RouteFallback';
import { useAlert } from '../context/AlertContext';


export const RouteGuard = ({ auth, setAuth, isSidebarOpen }) => {
  const { setAlert } = useAlert();
  const userType = auth?.userType;
  const validUserType = Boolean(userType && Object.values(USER_TYPES).includes(userType));

  // A signed-in user without a valid userType must not reach protected routes.
  useEffect(() => {
    if (auth?.isLoggedIn && !validUserType) {
      console.error('RouteGuard: Invalid or undefined userType:', userType, 'User cannot access protected routes');
      setAlert({
        type: 'failure',
        msg: 'Access denied: Invalid user permissions. Please contact support.',
        visible: true
      });
    }
  }, [auth?.isLoggedIn, validUserType, userType, setAlert]);

  if (!auth?.isLoggedIn) {
    console.warn('RouteGuard: User not authenticated, this should be handled by App.js');
    return <Navigate to="/" replace />;
  }

  if (!validUserType) {
    return <Navigate to="/" replace />;
  }
  
  const routes = getRoutesByUserType(userType);
  // Determine homepage route based on user type
  const fallbackPath = userType === USER_TYPES.WHOLESALER ? '/credits' : '/overview';

  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        {routes.map((route, index) => (
          <Route
            key={`${route.path}-${index}`}
            path={route.path}
            element={
              <ProtectedRoute
                element={route.element}
                permission={route.permission}
                auth={auth}
                setAuth={setAuth}
                isSidebarOpen={isSidebarOpen}
                fallbackPath={fallbackPath}
              />
            }
            {...(route.exact && { exact: true })}
          />
        ))}
      </Routes>
    </Suspense>
  );
};

export default RouteGuard;
